import useSWR from 'swr';
import { useMemo } from 'react';
// utils
import axios, { fetcher, endpoints } from 'src/utils/axios';
import { IResponse } from 'src/types/DTO/IResponse';
import { SWRConfiguration } from 'swr/_internal';
import { integrateIdToURL } from 'src/utils/string';
import { IParamBasic } from 'src/types/ParamBasic';
import { IAccount } from 'src/types/DTO/account/IAccount';
import { IResponseSingle } from 'src/types/DTO/reponse/IReponseSingle';
import { IAccountDetail } from 'src/types/DTO/account/IAccountDetail';

// types

// ----------------------------------------------------------------------

// XỬ LÝ API TÀI KHOẢN

// ----------------------------------------------------------------------

export function useGetAccounts(
  params?: IParamBasic & {
    statusIds?: number[];
  }
) {
  const URL = params
    ? [
        endpoints.account.root,
        {
          params: {
            ...params,
          },
        },
      ]
    : endpoints.account.root;

  const { data, isLoading, error, isValidating, mutate } = useSWR<IResponse<IAccount[]>>(
    URL,
    fetcher
  );

  // console.log(data, isLoading, error, isValidating);

  const accounts = data?.data.list;
  const memoizedValue = useMemo(
    () => ({
      data: {
        status: data?.status,
        message: data?.message,
        data: {
          list: accounts || [],
          pagination: data?.data.pagination,
        },
      },
      isLoading,
      error,
      isValidating,
      mutate,
    }),
    [data, isLoading, error, isValidating, mutate]
  );

  return memoizedValue;
}

// ----------------------------------------------------------------------

export function useGetAccount(id: number, option?: SWRConfiguration) {
  const URL = id ? endpoints.account.find_by_id + id : null;

  const { data, isLoading, error, isValidating, mutate } = useSWR<IResponseSingle<IAccountDetail>>(
    URL,
    fetcher,
    option
  );

  const account = data?.data;
  const memoizedValue = useMemo(
    () => ({
      data: {
        status: data?.status,
        message: data?.message,
        data: {
          ...account,
        },
      },
      isLoading,
      error,
      isValidating,
      mutate,
    }),
    [data, error, isLoading, isValidating, mutate]
  );

  return memoizedValue;
}

// ----------------------------------------------------------------------

export async function createAccount(formData: any) {
  const URL = endpoints.account.create;

  const { data } = await axios.post(URL, formData);

  return data;
}

// ----------------------------------------------------------------------

export async function updateAccount(id: number, formData: any) {
  const URL = integrateIdToURL(endpoints.account.update, id);

  const { data } = await axios.put(URL, formData);

  return data;
}

// ----------------------------------------------------------------------

export async function changePassword(oldPassword: string, newPassword: string) {
  const URL = endpoints.account.change_password;

  const { data } = await axios.put(URL, {
    oldPassword,
    newPassword,
  });

  return data;
}

// ----------------------------------------------------------------------

export async function deleteAccounts(ids: number[]) {
  const URL = endpoints.account.delete;

  const { data } = await axios.put(URL, { ids } as any);

  return data;
}

// ----------------------------------------------------------------------
